// removed by extract-text-webpack-plugin
module.exports = {"genres":"GenreList__genres-19ocb","genre":"GenreList__genre-3r0Fx"};